var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataHistogramFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.3584C7.5 3.32286 8.33947 2.4834 9.375 2.4834H10.625C11.6605 2.4834 12.5 3.32286 12.5 4.3584V17.5001H12.2917C12.2186 17.5001 12.1485 17.4875 12.0833 17.4645C12.0182 17.4875 11.948 17.5001 11.875 17.5001H8.125C8.05195 17.5001 7.98183 17.4875 7.91666 17.4645C7.8515 17.4875 7.78138 17.5001 7.70833 17.5001H7.5V4.3584Z",
    fill: "#1D72E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.3334H4.375C3.33947 8.3334 2.5 9.17286 2.5 10.2084V16.8751C2.5 17.2202 2.77982 17.5001 3.125 17.5001H6.25V8.3334Z",
    fill: "#1D72E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.5001H16.875C17.2202 17.5001 17.5 17.2202 17.5 16.8751V7.7084C17.5 6.67286 16.6605 5.8334 15.625 5.8334H13.75V17.5001Z",
    fill: "#1D72E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataHistogramFilled);
export default __webpack_public_path__ + "static/media/data_histogram_filled.a47218855a3bd16f4a33321db5c66172.svg";
export { ForwardRef as ReactComponent };